/**
 * @returns {object} - list of available columns in MyTradera.
 */
export enum columns {
    CurrentPrice = 'CurrentPrice',
    TransactionDate = 'TransactionDate',
    EndDate = 'EndDate',
    ShippingCost = 'ShippingCost',
    Bids = 'Bids',
    ItemId = 'ItemId',
    OpeningBid = 'OpeningBid',
    ReservePrice = 'ReservePrice',
    BuyItNow = 'BuyItNow',
    OwnReference = 'OwnReference',
    Discount = 'Discount',
    MaxBid = 'MaxBid',
    TimeLeft = 'TimeLeft',
    MandatoryBuyerProtection = 'MandatoryBuyerProtection'
}

type ColumnGroup = {
    Basic: columns[];
    Normal?: columns[];
};

export const buyerActiveItemsColumns: ColumnGroup = {
    Basic: [
        columns.CurrentPrice,
        columns.MaxBid,
        columns.Bids,
        columns.ShippingCost,
        columns.EndDate,
        columns.TimeLeft,
        columns.ItemId
    ]
};

export const buyerItemsLostColumns: ColumnGroup = {
    Basic: [
        columns.CurrentPrice,
        columns.MaxBid,
        columns.Bids,
        columns.ShippingCost,
        columns.EndDate,
        columns.ItemId
    ]
};

export const sellerActiveColumns: ColumnGroup = {
    Basic: [
        columns.CurrentPrice,
        columns.Bids,
        columns.EndDate,
        columns.ItemId,
        columns.ReservePrice,
        columns.OwnReference
    ]
};

export const sellerUnsoldColumns: ColumnGroup = {
    Basic: [
        columns.CurrentPrice,
        columns.Bids,
        columns.ShippingCost,
        columns.EndDate,
        columns.ItemId,
        columns.OwnReference
    ]
};
